import React, { useEffect, useState } from "react";
import { Dialog } from "@material-ui/core";
import { CloseButton } from "../../pages/dashboard/styles";
import { StyledPaper } from "../addBankPopup/styles";
import { FunctionalButton } from "../functionalButton";
import { FormTitle } from "../../pages/homePage/styles";
import PledgxLogo from "assets/common/pledgxLogo";
import CloseIcon from "@material-ui/icons/Close";
import Input from "../inputField";
import { AddressAutoFields } from "../addClientPopup/AddressAutoFields";
import { SmallTitleText } from "../../pages/underwriterDashboard/idpDocuments/styles";
import Success from "../../assets/dashboardIcons/Success";
import { AlertPopup } from "../alertPopup/alertPopup";
import {
  addNewSubsidiaryAccount,
  editSubsidiaryAccount,
} from "../../api/external_data";
import { addUnderwriterSubAccount, editUnderwriterSubAccount } from "../../data/actions/underwriters";
import { useDispatch } from "react-redux";

export const EditSubsidiaryAccountPopup = ({ open, setOpen, subsidiary }) => {
  const [form, setForm] = useState({
    subsidiaryName: "",
  });

  const [fullAddress, setFullAddress] = useState({
    address: "",
    suite: "",
    postal: "",
    city: "",
    province: "",
    country: "",
  });

  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [error, setError] = useState("");

  const [showSuccessDialog, setShowSuccessDialog] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    console.log("xz: ", subsidiary);

    setForm({
      subsidiaryName: subsidiary.SubsidiaryName,
      subsidiaryId: subsidiary.SubsidiaryID,
      accountId: subsidiary.accountId,
      companyName: subsidiary.companyName,
    });

    setFullAddress({
      address: subsidiary.SubsidiaryAddress,
      suite: subsidiary.SubsidiarySuite,
      postal: subsidiary.SubsidiaryPostCode,
      city: subsidiary.SubsidiaryCity,
      province: subsidiary.SubsidiaryProvince,
      country: subsidiary.SubsidiaryCountry,
    });
  }, [subsidiary]);

  const handleConfirm = async () => {
    console.log("Submitting Subsidiary Account: ", form);
    console.log("Full Address: ", fullAddress);

    const data = {
      accountId: form.accountId.toString(),
      subsidiaryID: form.subsidiaryId,
      subsidiaryName: form.subsidiaryName,
      subsidiaryAddress:
        fullAddress.address ?? fullAddress.company?.address ?? "",
      subsidiarySuite: fullAddress.suite ?? fullAddress.company?.suite ?? "",
      subsidiaryCity: fullAddress.city ?? fullAddress.company?.city ?? "",
      subsidiaryProvince:
        fullAddress.province ?? fullAddress.company?.province ?? "",
      subsidiaryPostCode:
        fullAddress.postal ?? fullAddress.company?.postal ?? "",
      subsidiaryCountry:
        fullAddress.country ?? fullAddress.company?.country ?? "",
    };

    console.log("Submission Data: ", data);

    try {
      await editSubsidiaryAccount(
        data,
        (response) => {
          dispatch(editUnderwriterSubAccount(response));
        },
        (error) => {
          console.error(error.message);
        },
      );

      setOpen(false);
      setShowSuccessDialog(true);
      console.log("Successfully added the new subsidiary!");
    } catch (e) {
      console.error("Failed to add the subsidiary: ", e);
      setError("Failed to add subsidiary account. Please try again.");
      setShowErrorDialog(true);
    }
  };

  const handleInputChange = (field, value) => {
    setForm((prevForm) => ({
      ...prevForm,
      [field]: value,
    }));
  };

  const handleAddressUpdate = (field, value) => {
    if (field === "company") {
      setFullAddress({ company: value });
    } else {
      const path = field.split(".");
      if (path.length === 2 && path[0] === "company") {
        setFullAddress((prev) => ({
          company: {
            ...prev.company,
            [path[1]]: value,
          },
        }));
      }
    }
  };

  return (
    <>
      <Dialog
        open={open}
        setOpen={setOpen}
        maxWidth="md"
        ModalProps={{ hideBackdrop: false }}
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
        maxWidth="md"
      >
        <StyledPaper elevation={1}>
          <PledgxLogo />
          <FormTitle style={{ paddingTop: "18px" }}>
            Edit Subsidiary Account
          </FormTitle>
          <SmallTitleText>{form.companyName}</SmallTitleText>
          <CloseButton onClick={() => setOpen(false)} aria-label="close">
            <CloseIcon />
          </CloseButton>
          <div style={{ padding: "20px 0", width: "100%" }}>
            <Input
              id="subsidiary-name"
              label="Subsidiary Name"
              type="text"
              labelSize="12px"
              fontSize="18px"
              validateFunc={(item) => Boolean(item)}
              setValue={(e) => handleInputChange("subsidiaryName", e)}
              value={form.subsidiaryName}
            />

            <AddressAutoFields
              data={fullAddress}
              setData={handleAddressUpdate}
              hasMargin
            />

            <div
              style={{
                marginTop: "30px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <FunctionalButton
                buttonTitle="Confirm"
                handleButton={handleConfirm}
              />
            </div>
          </div>
        </StyledPaper>
      </Dialog>

      <Dialog
        open={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        maxWidth="md"
      >
        <StyledPaper elevation={0}>
          <CloseButton
            onClick={() => setShowSuccessDialog(false)}
            aria-label="close"
          >
            <CloseIcon />
          </CloseButton>
          <Success />
          <FormTitle
            style={{ marginTop: "30px", fontSize: "22px", fontWeight: "600" }}
          >
            Success
          </FormTitle>
          <SmallTitleText style={{ marginBottom: "30px" }}>
            The subsidiary account has been successfully created.
          </SmallTitleText>
          <FunctionalButton
            buttonTitle="Close"
            handleButton={() => setShowSuccessDialog(false)}
          />
        </StyledPaper>
      </Dialog>

      <AlertPopup
        headerText="Subsidiary Account Creation Failed"
        subHeaderText={error}
        openPopup={showErrorDialog}
        setOpenPopup={setShowErrorDialog}
        showIcon={true}
      />
    </>
  );
};

export const AddSubsidiaryAccountPopup = ({
  open,
  setOpen,
  accountId,
  companyName,
  userId,
}) => {
  const [form, setForm] = useState({
    subsidiaryName: "",
    subsidiaryAddress: "",
  });

  const [fullAddress, setFullAddress] = useState({
    address: "",
    suite: "",
    postal: "",
    city: "",
    province: "",
    country: "",
  });

  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [error, setError] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    if (!open) {
      setForm({
        subsidiaryName: "",
        subsidiaryAddress: "",
      });
      setFullAddress({
        address: "",
        suite: "",
        postal: "",
        city: "",
        province: "",
        country: "",
      });
    }
  }, [open]);

  const handleInputChange = (field, value) => {
    setForm((prevForm) => ({
      ...prevForm,
      [field]: value,
    }));
  };

  const handleConfirm = async () => {
    console.log("Submitting Subsidiary Account: ", form);
    console.log("Full Address: ", fullAddress);

    const data = {
      accountId: accountId.toString(),
      user_id: userId,
      subsidiaryName: form.subsidiaryName,
      subsidiaryAddress: fullAddress.address,
      subsidiarySuite: fullAddress.suite,
      subsidiaryCity: fullAddress.city,
      subsidiaryProvince: fullAddress.province,
      subsidiaryPostCode: fullAddress.postal,
      subsidiaryCountry: fullAddress.country,
    };

    console.log("Data: ", data);

    try {
      await addNewSubsidiaryAccount(
        data,
        (response) => {
          dispatch(addUnderwriterSubAccount(response));
        },
        (error) => {
          console.error(error.message);
        },
      );

      setOpen(false);
      setShowSuccessDialog(true);
      console.log("Successfully added the new subsidiary!");
    } catch (e) {
      console.error("Failed to add the subsidiary: ", e);
      setError("Failed to add subsidiary account. Please try again.");
      setShowErrorDialog(true);
    }
  };

  return (
    <>
      <Dialog
        open={open}
        setOpen={setOpen}
        aria-labelledby="add-subsidiary-account-dialog"
        maxWidth="md"
      >
        <StyledPaper elevation={0}>
          <PledgxLogo />
          <FormTitle style={{ paddingTop: "18px" }}>
            Add Subsidiary Account
          </FormTitle>
          <SmallTitleText>{companyName}</SmallTitleText>
          <CloseButton onClick={() => setOpen(false)} aria-label="close">
            <CloseIcon />
          </CloseButton>
          <div style={{ padding: "20px 0", width: "100%" }}>
            <Input
              id="subsidiary-name"
              label="Subsidiary Name"
              type="text"
              labelSize="12px"
              fontSize="18px"
              validateFunc={(item) => Boolean(item)}
              setValue={(e) => handleInputChange("subsidiaryName", e)}
              value={form.subsidiaryName}
            />

            <AddressAutoFields
              data={form.subsidiaryAddress}
              setData={(e, val) => {
                setFullAddress((address) => {
                  if (e === "company") {
                    return {
                      city: val.city,
                      address: val.address,
                      suite: val.suite,
                      postal: val.postal,
                      country: val.country,
                      province: val.province,
                    };
                  }
                  return {
                    ...address,
                    [e.split(".").slice(1).join(".")]: val,
                  };
                });
              }}
              hasMargin
            />

            <div
              style={{
                marginTop: "30px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <FunctionalButton
                buttonTitle="Confirm"
                handleButton={handleConfirm}
              />
            </div>
          </div>
        </StyledPaper>
      </Dialog>

      <Dialog
        open={showSuccessDialog}
        onClose={() => setShowSuccessDialog(false)}
        maxWidth="md"
      >
        <StyledPaper elevation={0}>
          <CloseButton
            onClick={() => setShowSuccessDialog(false)}
            aria-label="close"
          >
            <CloseIcon />
          </CloseButton>
          <Success />
          <FormTitle
            style={{ marginTop: "30px", fontSize: "22px", fontWeight: "600" }}
          >
            Success
          </FormTitle>
          <SmallTitleText style={{ marginBottom: "30px" }}>
            The subsidiary account has been successfully created.
          </SmallTitleText>
          <FunctionalButton
            buttonTitle="Close"
            handleButton={() => setShowSuccessDialog(false)}
          />
        </StyledPaper>
      </Dialog>

      <AlertPopup
        headerText="Subsidiary Account Creation Failed"
        subHeaderText={error}
        openPopup={showErrorDialog}
        setOpenPopup={setShowErrorDialog}
        showIcon={true}
      />
    </>
  );
};
